/**
 * Milestones for retailers who have installed the retailer Faire app on Shopify
 */ export var SHOPIFY_LEAD_ELIGIBLE_FOR_INCENTIVES = 'SHOPIFY_LEAD_ELIGIBLE_FOR_INCENTIVES';
